import { motion } from 'framer-motion';
import { LuX } from 'react-icons/lu';
import styled from 'styled-components';

export const BackgroundModal = styled(motion.div)`
    width: 100%;
    height: 100%;

    background: rgb(0, 0, 0, 0.6);
    position: fixed;
    z-index: 999;
    top: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px) {
        padding-top: 0;
    }
`;

export const ModalWrapper = styled.div`
    max-width: calc(100% - 2rem);
    max-height: 90vh;
    height: fit-content;

    box-shadow: 0 0.3125rem 1rem rgba(0, 0, 0, 0.2);
    background: #fff;
    color: #000;
    position: relative;
    z-index: 10000;
    border-radius: 0;
    padding: 0;
    overflow: hidden;

    display: flex;
    flex-direction: column;
`;

export const ModalContent = styled.div`
    color: ${({ theme }) => theme.colors['neutral-900']};
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-height: calc(90vh - 2rem);
    overflow: hidden;
`;

export const CloseModalButton = styled(LuX)`
    cursor: pointer;
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
    width: 2rem;
    height: 2rem;
    padding: 0;
    z-index: 10001;
    color: #000;
`;

export const ImageWrap = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 100%;
        max-width: 100%;
        max-height: calc(90vh - 2rem);
        height: auto;
        object-fit: contain;
        border-radius: 0;
        display: block;
    }
`;
